var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"subtitle has-text-centered locker-name"},[_vm._v("\n  "+_vm._s(_vm.name)+"\n  "),_c('hr',{staticStyle:{"margin":"0.7rem 0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }